import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';
import './../../../styles/global.scss';
import Skeleton from 'react-loading-skeleton';

class DoughnutComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chartData: {
                labels: this.props.labels.map(function (label) {return label.charAt(0).toUpperCase() + label.substring(1)}),
                datasets: [{
                    label: 'Doughnut Chart',
                    backgroundColor: [
                        'rgba(219, 220, 43, 1)',
                        'rgba(122,33,130, 1)',
                        'rgba(238, 112, 33, 1)',
                        'rgba(122,191,128, 1)',
                        'rgba(224,0,105, 1)',
                        'rgba(0, 113, 185,1)',
                        'rgba(0, 56, 67,1)', 
                    ], 
                    data: this.props.data,
                }]
            }, 
            responsive: true
        };
    }

    render() {
        return (
            <div className="chart">

                <Doughnut
                    width={0}
                    responsive={true}
                    data={this.state.chartData || <Skeleton />}
                    options={{
                        title: {
                            display: true,
                            text: this.props.title || <Skeleton />
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }}
                />
            </div>
        )
    }
}

export default DoughnutComponent;
